// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c6cedc67","232":"88cb8e0f","315":"5abf4d2a","503":"fa584b08","764":"1ca3b9cb","777":"cbc36638","941":"ac2c3e6f"}[chunkId] + ".chunk.js";
};